import { GetAllGGNotificationDTO, GetAllGGNotificationFiltersDTO, GGNotificationDTO, GGNotificationUpdateDTO } from "./dto";
import { GGNotificationServiceImpl } from "./serviceImpl";

export interface GGNotificationService {
    CreateGGNotification(data: GGNotificationUpdateDTO): Promise<void>
    GetAllGGNotification(filters: GetAllGGNotificationFiltersDTO): Promise<GetAllGGNotificationDTO>
    GetGGNotificationById(id: string): Promise<GGNotificationDTO>
    UpdateGGNotification(data: GGNotificationUpdateDTO, id: string): Promise<void>
}

export function NewGGNotificationService(): GGNotificationService {
    return new GGNotificationServiceImpl()
}